<section
  id="inicio"
  class="d-flex align-items-center justify-content-center mt-5"
>
  <div class="container">
    <div class="row mt-5">
      <div class="col-12 d-md-none">
        <br />
        <br />
        <br />
        <br />
      </div>
      <div class="col-md-6 mt-5 text-end text-white my-auto p-4">
        <h1 class="font-montserrat-bold">
          <br />
          Gerencie e anuncie sua vidraçaria ou serralheria na palma da sua mão!
        </h1>
        <p class="fs-5 mt-2 font-montserrat">
          Junte-se a comunidade de profissionais que utilizam a tecnologia para
          reduzir o trabalho e aumentar os lucros!
        </p>

        <button
          class="btn botao animation rounded-pill p-3 px-4 font-weight-bold"
          (click)="btnDownload()"
        >
          FAÇA O TESTE GRÁTIS <i class="fas fa-arrow-right"></i>
        </button>

        <!--  <button class="btn float-end btn-warning text-muted d-none d-md-block" data-bs-toggle="modal"
                data-bs-target="#modalvideo"><span class="fs-3">Assistir </span> <i
                  class="far fa-play-circle fa-2x"></i>
                </button> -->
      </div>
      <div class="col-md-6">
        <img
          src="./assets/img/mvSmart.png"
          class="w-75 img img-fluid"
          width="100%"
          alt=" imagem Peterson Azevedo"
        />
        <!-- <button class="btn btn-warning text-muted d-md-none" data-bs-toggle="modal"
              data-bs-target="#modalvideo"><span class="fs-3">Assistir </span> <i
                  class="far fa-play-circle fa-2x"></i>
          </button> -->
      </div>
    </div>
  </div>

  <!-- Modal -->
  <!-- <div class="modal fade" id="modalvideo" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title" id="staticBackdropLabel"><img src="./assets/img/logo.svg"
                          alt="logomarca meuvidraceiro" height="36"></h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                  <video width="100%" controls>
                      <source src="./assets/video/video.mp4" type="video/mp4">
                      Seu navegador não suporta vídeo HTML.
                  </video>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
              </div>
          </div>
      </div>
  </div> -->
</section>
<!--section id="conquista">
  <br>
  <br>
  <br>
  <br>
  <img class="img-absolute" src="./assets/img/fundoConquista.svg" width="500" alt="imagem fundo section conquistas">
  <h1 class="text-center mb-5">UMA PEQUENA LISTA DO QUE VOCÊ IRÁ <span
          class="bg-warning text-muted px-3 rounded-pill">CONQUISTAR</span></h1>



  <div class="row mb-5 mx-2  ">
      <div class="col-md-4">
          <div class="card card-conquista">
              <img src="./assets/img/tempo.svg" alt="imagem tempo">
          </div>

      </div>
      <div class="col-md-4 ">
          <div class="card card-conquista">
              <img src="./assets/img/credibilidade.svg" alt="credibilidade">
          </div>

      </div>
      <div class="col-md-4 ">
          <div class="card card-conquista">
              <img src="./assets/img/gestao.svg" alt="gestao">

          </div>
      </div>
      <div class="col-md-4 ">
          <div class="card card-conquista">
              <img src="./assets/img/descentralizacao.svg" alt="descentralizacao">

          </div>
      </div>
      <div class="col-md-4 ">
          <div class="card card-conquista">
              <img class="card-img-top" src="./assets/img/maisvendas.svg" alt="maisvendas">
          </div>
      </div>
  </div>
</section>
<div class="container-fluid chamada text-white">
  <h3 class="text-center text-light pt-5 text-uppercase">Baixe agora mesmo! <br>e cadastre-se</h3>
  <p class="text-center lead text-light">A unica coisa que você ira perder é a oportunidade de mudar o jeito como
      seus
      clientes
      vêem sua vidraçaria.</p>

  <div class="d-flex align-items-center  pb-5 justify-content-center flex-column">
      <div class="  row mb-4">
          <a href="https://play.google.com/store/apps/details?id=br.com.zemt.zemtVidraceiro" target="_blank"
              class="btn text-white col-md-4 ">
              <img src="./assets/img/google-play.svg" width="170" class=" img-fluid rounded" alt="">
          </a>
          <a href="https://apps.apple.com/br/app/meu-vidraceiro/id1479886116" target="_blank"
              class="btn text-white col-md-4 ">
              <img src="./assets/img/app-store.svg" width="170" class="img-fluid rounded" alt="">

          </a>
          <a href="https://app.meuvidraceiro.com.br" target="_blank" class="btn text-white col-md-4 ">
              <img src="./assets/img/web.svg" width="170" class="img-fluid rounded" alt="">
          </a>
      </div>
      <button type="button" (click)="btnDownload()" class="m-0 pulse btn btn-warning text-uppercase p-3  ">
          faça o teste grátis
      </button>
  </div>
</div-->

<!--section id="beneficios" class="pb-5 mb-5">
  <br>
  <br>
  <br><br>
  <div class="ms-3 mb-5 row">
      <div class="py-2 card shadow border-0 rounded-pill col-md-4 text-muted text-center">
          <h4>BENEFICÍOS?<br>São MUITOS...</h4>
      </div>
  </div>
  <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
          <button *ngFor="let item of beneficios ; let i = index " type="button" data-bs-target="#carouselExampleDark"
              [attr.data-bs-slide-to]="i" [class.active]="i == 0" aria-current="true"
              [attr.aria-label]="'Slide'+(i+1)">
          </button>
      </div>
      <div class="carousel-inner py-5">
          <div class="carousel-item text-center" data-bs-interval="3000" [class.active]="i == 0"
              *ngFor="let item of beneficios ; let i = index ">

              <img [src]="'./assets/img/'+item.img" height="320px" class="img-max-w" alt="imagem carousel">
              <div class=" text-center bg-warning py-4 ">
                  <h1 class="lead">{{item.beneficio}}</h1>
              </div>
          </div>
      </div>

  </div>


</section-->

<section id="funcionalidade">
  <br />
  <br />
  <br />
  <br />
  <div class="row mx-3 mt-2 mb-5">
    <div class="col-md-5 offset-md-2">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="mt-5 col-md-12 mb-4">
          <h1 class="text-ae font-montserrat-bold">
            Gerencie seu negócio com segurança
          </h1>
          <p class="size_sub">
            Com o aplicativo Meu Vidraceiro, sua vidraçaria ou serralheria passa
            a ser digital, assim você pode realizar qualquer tarefa do dia-a-dia
            de um jeito rápido, simples e seguro.
          </p>
        </div>
        <div class="col-md-2">
          <i class="text-ae fas fa-users fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Cadastro de Clientes</h5>
          <p class="card-text">
            Mantenha os dados dos seus clientes salvos em um ambiente seguro
          </p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae fas fa-layer-group fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Projeto para Têmpera</h5>
          <p class="card-text">
            Emita projetos detalhados para seu fornecedor de vidros.
          </p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae fas fa-briefcase fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Galeria de Projetos</h5>
          <p class="card-text">
            Ampla galeria com centenas de projetos de vidros e esquadrias para
            utilizar
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <img src="./assets/img/app-mv1.png" class="img-fluid" width="300" />
    </div>
  </div>
  <hr class="border border-warning w-50 mx-auto" />
  <hr class="border border-warning w-75 mx-auto" />
  <hr class="border border-warning w-25 mx-auto" />
  <div class="row mx-3">
    <div class="col-md-4 offset-md-2 text-end">
      <img src="./assets/img/app-mv2.png" width="300" class="img-fluid" />
    </div>

    <div class="col-md-5 mt-4">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-2 text-end">
          <i class="text-ae fas fa-calculator fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Calculadora</h5>
          <p class="">
            Faça medições e contas rápidas para elaborar orçamentos na hora
          </p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae far fa-building fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Fornecedores</h5>
          <p class="">Cadastre os fornecedores de sua empresa</p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae fas fa-cash-register fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Financeiro</h5>
          <p class="">Relação de lucro/despesas das suas obras</p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae far fa-paper-plane fa-2x"></i>
        </div>
        <div class="col-md-9">
          <h5 class="text-ae font-montserrat-bold">Envio de orçamento</h5>
          <p class="">Envie orçamentos para clientes de forma personalizada</p>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div class="col-md-2">
          <i class="text-ae far fa-folder-open fa-2x"></i>
        </div>
        <div class="col-md-9 mb-5">
          <h5 class="text-ae font-montserrat-bold">Materiais</h5>
          <p class="">
            Lista de produtos para realizar orçamentos e compras em fornecedores
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="container-fluid chamada text-white py-5">
  <h3 class="text-center text-light pt-5 font-montserrat-bold">
    Baixe agora mesmo!
  </h3>
  <h6 class="text-center size_sub mt-3 mb-2">
    A única coisa que você irá perder é a oportunidade de mudar o jeito como
    seus clientes vêem sua empresa.
  </h6>

  <div
    class="d-flex align-items-center pb-5 justify-content-center flex-column"
  >
    <div class="row mb-4">
      <a
        href="https://play.google.com/store/apps/details?id=br.com.zemt.zemtVidraceiro"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/google-play.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
      <a
        href="https://apps.apple.com/br/app/meu-vidraceiro/id1479886116"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/app-store.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
      <a
        href="https://app.meuvidraceiro.com.br"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/web.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
    </div>

    <button
      class="btn botao animation rounded-pill p-3 px-4 font-weight-bold"
      (click)="btnDownload()"
    >
      FAÇA O TESTE GRÁTIS <i class="fas fa-arrow-right"></i>
    </button>
  </div>
</div>

<section id="palavras-chaves">
  <h1>Software e sistema para vidraçarias</h1>
  <h1>Melhores Softwares e sistemas para vidraçarias</h1>
  <h1>Melhorer Softwares e sistemas para vidraçarias</h1>
  <h1>sistema para vidraçarias</h1>
  <h1>Software para vidraçarias</h1>
  <h1>Programa para vidraçarias</h1>
  <h1>app para vidraçarias</h1>
  <h1>aplicativo para vidraçarias</h1>
  <h1>vidraçaria</h1>
</section>
<!-- <section id="temp" class="mt-2  ">
  <br>
  <br>
  <br>
  <div class="d-flex align-items-center w-100 justify-content-center  p-2 ">
      <div class="animate-svg w-100  py-2">
          1291.43 356.24 
          <svg viewBox="-250 -70 1891.43 456.24">
              <path class="cls-1"
                  d="M238.2,81.71A.47.47,0,0,0,238,82a1.41,1.41,0,0,1-.08.4l6.57,6.42Q227,136.48,174.05,145.78a51.82,51.82,0,0,1-6.66.84c-2.19.14-4.35.2-6.49.2q-20.78,0-33.84-13.07l-2.33-2.24q-2.24-1.77-4.37-3.81a44.57,44.57,0,0,1-4-4.37,54.49,54.49,0,0,1-8.9-15.6,50.48,50.48,0,0,1-2.88-17.12c0-1.71,0-3.41.16-5.09a46.15,46.15,0,0,1,.56-4.93,70,70,0,0,1,6.41-20.33,93.2,93.2,0,0,1,12.59-19,88.74,88.74,0,0,1,18.2-16.72,84.2,84.2,0,0,1,22.06-10.63,93.27,93.27,0,0,1,13.87-3.53,78.51,78.51,0,0,1,12.91-1.12q18,0,34.48,12.67l-.4.32,6.49,6.42L202.76,47.79a28.51,28.51,0,0,0-7.5-3.65A26.83,26.83,0,0,0,187.44,43a47.63,47.63,0,0,0-13.31,2.09A39.65,39.65,0,0,0,152,61.18a43.2,43.2,0,0,0-9.06,22.7,6.09,6.09,0,0,0-.17,1.36v1.28a29.47,29.47,0,0,0,3.85,14.92,22.51,22.51,0,0,0,13.15,3.85,36.12,36.12,0,0,0,7.14-.89A49.73,49.73,0,0,0,188,95.06a44.63,44.63,0,0,0,13.43-18Zm-34.64-1q-9.3,21.65-36,27.1-17.88,3.45-27.5-8.18-7.94-9.61-7-23a47.91,47.91,0,0,1,9.62-24.06,43.12,43.12,0,0,1,23.82-17.32q18.21-5.3,29.43,2.09l23.9-15.72q-20.37-15.31-54.21-4.57a81.7,81.7,0,0,0-38.73,26.3q-15,17.88-18.12,38.09-3.54,22.53,9.54,38.81,16.27,21.09,48.27,15.64,51.72-8.91,67-51.32Z" />
              <path class="cls-1"
                  d="M302.91,24.78c-.27,2-.53,4.34-.8,6.93s-.56,5.39-.88,8.38-.63,6.14-.93,9.43-.6,6.64-.92,10.06q3.38-.88,6.9-1.84c2.35-.65,4.89-1.31,7.62-2,2.56-.69,5.06-1.35,7.49-2s4.67-1.19,6.7-1.73l-.4-9.7q-.4-5.06-.84-10c-.3-3.29-.6-6.38-.93-9.27s-.64-5.54-1-8-.59-4.51-.8-6.22L355.92,0V1.12l6.41,6.26Q363,17.57,364.5,30t3.84,27.46q1.46,9.39,3.05,18.89t3.29,18.76q1.68,9.27,3.41,18.21t3.41,17.12l-42,11.86-6.58-6.41-.72.16c-.16-3.48-.32-7.23-.48-11.27s-.34-8.23-.52-12.59-.38-8.8-.56-13.35-.39-9.09-.61-13.63q-7,2-15.07,3.85c-2.94.69-5.93,1.39-9,2.08s-6.12,1.34-9.22,1.93l-1.05,16.68q-.24,5.3-.52,10.66T294.69,131c-.13,3.45-.27,6.79-.4,10s-.25,6.24-.36,9l-38.33,4.25L249,147.71l-.8.08c.48-2.57,1.05-5.55,1.69-8.94s1.31-7,2-10.83,1.38-7.78,2.05-11.87,1.29-8.14,1.88-12.15q1.77-12,3.29-23.13t2.72-21.61q.57-4,1.09-8.06t1-7.94q.44-3.88.8-7.42t.6-6.41l31.36-12.19a1.38,1.38,0,0,0-.16.64v.48Zm68.16,96.79q-3.45-16.53-6.57-34t-6-36.45q-4.73-29.19-5.77-46.67l-24.7,7q1.44,10.09,3.13,30.63l.56,12.43Q325,56.37,314.86,59q-8.17,2.08-14.72,3.77t-11.58,2.88q1-13.71,2-24.41t2-18.65l-24,9.3q-.55,5.94-1.36,12.83T265.3,59.66Q264,70.09,262.54,81.19t-3.33,23.21q-1.77,12-3.41,21.9T252.55,144l31.6-3.61q.32-8.26.72-17.64t1-20L287,83.64q5.3-1,10.39-2t10.06-2.2q13.56-3.45,25.26-6.74.88,16.36,1.6,31t1.13,27.87Z" />
              <path class="cls-1"
                  d="M503.14,96.47l6.42,6.33,1.52,30.47-3.37.56-3.69.65c-1.23.21-2.39.4-3.48.56s-2,.32-2.77.48c-2.46.43-4.57.77-6.34,1s-3.2.51-4.33.72q-10.58,1.92-22.13,4.13T441.44,146q-12,2.41-24.18,4.93t-24.06,5.18l-6.49-6.5a1.61,1.61,0,0,1-.48.08.74.74,0,0,0-.4.16q2.24-16.27,4.41-32.72T394.41,85q2-15.76,3.8-30.39t3.25-27.23l19.21-5.65L436.58,17q11.4-3.37,19.65-5.93T470.3,6.66q5.82-1.85,9.59-3.13t6.25-2.17V2.49l6.5,6.25,2,21.41q-5.2,1.37-10.94,3L472,36.41q-6,1.68-12.11,3.4l-12,3.41-13.63,4.25c-.16,1.44-.31,3-.44,4.77s-.26,3.62-.36,5.66l6.45-1.73q3.17-.84,6.38-1.72c2.62-.7,5.5-1.5,8.66-2.41s6.36-1.85,9.62-2.84,6.48-2,9.66-3,6.14-1.94,8.86-2.85v1l6.42,6.42-.56,24.7L481.49,77q-3.93.81-8.06,1.72l-8.34,1.89c-2.8.64-5.55,1.28-8.22,1.92q-3.69,1-7.54,2l-7.77,2h-.16q-5,1.45-10.11,2.65c-.27,3.8-.48,7.44-.64,10.94s-.32,7-.48,10.39q12.51-2.89,24.1-5.49t22-4.77l4.29-.81,4.21-.8c1.55-.27,3.26-.57,5.13-.92s3.77-.68,5.69-1l4-.68,3.49-.61Zm-3.29,3q-5.28,1-10.94,2t-11.75,2.2q-25.5,5.3-57.25,12.75.39-17.07,1.68-36.4l14.35-3.73q6.9-1.8,13.39-3.57,8-1.92,15.44-3.61t14.31-3.13l.41-17.88q-8.26,2.66-16.28,5.05t-16,4.5q-6,1.6-12.07,3.12t-12.31,2.89q1.13-17.64,1.69-25.42l15.71-4.81Q452,30.07,463,27t21.53-5.89L483.17,6q-5,1.85-24.61,7.82T404.59,30Q401.71,55.33,398.05,84T390,145.46q47.22-10.43,89.73-18c1.81-.32,4.49-.78,8-1.36s8-1.31,13.31-2.17Z" />
              <path class="cls-1"
                  d="M575,85.8a2,2,0,0,1-.88.16l1-25.9,5.41-1.12q3.09-.64,6.7-1.45c2.4-.53,4.92-1.1,7.54-1.72s5.23-1.27,7.85-2c3.1-.81,6.38-1.67,9.83-2.61s6.92-1.9,10.42-2.89l10.31-2.92q5-1.45,9.54-2.81a2.16,2.16,0,0,0,.16,1L649.24,50c.49,3.2,1,6.52,1.57,9.94s1.12,6.82,1.68,10.18,1.14,6.63,1.73,9.79,1.12,6.09,1.6,8.82q2.32,11.79,4.53,21.49t4.53,17.48L621.9,140l-6.34-6.18a99.75,99.75,0,0,1-16.39,8,100.54,100.54,0,0,1-17.69,4.89q-2.81.4-5.53.69c-1.82.18-3.61.28-5.37.28q-19.56,0-32.72-13l-2.48-2.49a37.79,37.79,0,0,1-5.26-4.73,68.26,68.26,0,0,1-4.69-5.69,50.41,50.41,0,0,1-10.42-31,60.36,60.36,0,0,1,.8-10A70.68,70.68,0,0,1,519.9,66.4,89.93,89.93,0,0,1,529.4,49a99,99,0,0,1,13.11-15.12,101.88,101.88,0,0,1,37.37-21,86.68,86.68,0,0,1,13.87-3.49A83.48,83.48,0,0,1,607,8.34a63.76,63.76,0,0,1,13.24,1.48,97.46,97.46,0,0,1,14.83,4.53l-.56.57,6.58,6.41-26,22.61a30.22,30.22,0,0,0-14.27-3.85,38.72,38.72,0,0,0-6.54.57,49.43,49.43,0,0,0-6.85,1.68h-.16a49.07,49.07,0,0,0-24,16.52h-.08a53,53,0,0,0-7.09,11.75A39.21,39.21,0,0,0,553,82.67a17.47,17.47,0,0,0-.08,1.77v1.68a32.12,32.12,0,0,0,1.16,8.7,28.06,28.06,0,0,0,3.73,8,19.19,19.19,0,0,0,11.39,3.53c1,0,2,0,3-.08a13.42,13.42,0,0,0,3-.48c.11,0,.17,0,.2,0s.09,0,.2,0h-.16a6.19,6.19,0,0,1,.88-.24c.27-.06.6-.15,1-.28l1.44-.52,2.28-.89V104q16.29-6.5,23.82-16.92-7.46,1.77-13.63,3.13t-9.87,2Zm79.31,33A370.44,370.44,0,0,1,646,82.43q-3.13-16.52-6-35.44-9,2.64-18,5.17t-18.36,4.93q-15.72,4-25.18,6l-.64,18.6q5.78-1.12,14.91-3.29t21.89-5.29q-3.6,22.77-32.71,34.16c-.91.32-1.85.63-2.81.92s-2,.58-3,.85q-17.24,3.6-26.7-10.11a33.36,33.36,0,0,1-6.09-23.41q1.2-13.08,10.9-25.42a52.58,52.58,0,0,1,25.5-17.56q16.92-4.89,28.15,1l20.69-17.88q-20.94-8.1-47.48.56-21.24,6.57-36.16,20.21a91.69,91.69,0,0,0-12.63,14.47,86.12,86.12,0,0,0-9.1,16.72,56.58,56.58,0,0,0-3.85,13.71q-3.45,21.73,8.9,38.41,16,22,46.11,17.16a94.48,94.48,0,0,0,43.14-19.73l.48,12Z" />
              <path class="cls-1"
                  d="M813.23,117.4l6.57,6.49-47.39,17.48L765.84,135l-.4.16q-3.37-4.58-6.66-9.83t-6.49-11.1c-2.2.53-4.28,1-6.26,1.48L740.42,117c-3.32.7-6.51,1.3-9.59,1.81s-6.13.87-9.18,1.08q-2.56,8.75-5.17,17t-4.69,14.72l-35.44-.16-6.42-6.42h-1.12q2.73-6.5,6-14.35t6.7-16.64q3.45-8.79,6.94-18.08t6.85-18.69q6-16.85,10.67-31.27t7.62-25.1l25.74-6.58c.1.27.2.52.28.77s.17.49.28.76l6,5.93a263.37,263.37,0,0,0,20.49,39.61,283,283,0,0,0,27,36q4.81,5.2,9.95,10.1t10.5,9.62Zm-6-1.45a270.74,270.74,0,0,1-69.92-97.43l-20.85,5.3Q713.4,34.4,709,48T698.56,78.42Q685.09,115.88,674,141.69l28.71.08q2.25-6.74,4.69-14.59t5.17-17q4.65-.41,9.74-1.16T733,107.13q7.79-1.75,17.32-4.33a210.27,210.27,0,0,0,16.28,28.07ZM742.58,86.12,735,88q-3,.76-4.44,1.08c-1.72.43-3.6.87-5.66,1.32s-4.32.92-6.77,1.41q7-24.78,11.06-40.18,3,8.74,6.26,17.28T742.58,86.12Zm-8.5-1.36a11,11,0,0,1,1.61-.44c.64-.13,1.33-.31,2.08-.52-.59-1.34-1.13-2.68-1.64-4s-1.06-2.65-1.65-3.93c-.48,1.49-1,3-1.4,4.65s-.9,3.23-1.32,4.89l1.08-.32C733.19,85,733.6,84.87,734.08,84.76Z" />
              <path class="cls-1"
                  d="M931.75,151.8l-1,.16q2-10.19,4-20.85t3.81-21.17q1.85-10.5,3.53-20.65t3-19.21q.89-6,1.64-11.74t1.37-10.87q.6-5.13,1.08-9.5t.8-7.74l50.12-15.72a72.74,72.74,0,0,1,10.94-2.68,66.7,66.7,0,0,1,10.55-.84,49.81,49.81,0,0,1,12.15,1.44,50.5,50.5,0,0,1,11.1,4.25,45.81,45.81,0,0,1,14.92,12.59l3,2.89q9.63,9.62,12.67,24.93a59.38,59.38,0,0,1,.85,5.94c.18,2,.28,4.12.28,6.25q0,19.81-12,39.13a82.38,82.38,0,0,1-23.42,25.14,77.38,77.38,0,0,1-31.59,12.31l-71.45,12.35ZM1043.37,19.73q-18-9.63-42.1-1.93L953.32,32.88q-.65,6.73-1.81,16.07t-2.92,21.54q-5.54,36.24-13.47,77.06l67.11-11.47q34.17-5.78,52.93-36.17,15.31-24.93,10.5-49.15Q1061.32,29.6,1043.37,19.73Zm-14.92,69q-8.34,18.19-26.54,22l-32,6.41q1.61-17.39,2.68-29.5t1.57-19.33q.63-7.69,1-13.91t.52-11q5.29-1.44,9.74-2.68t8.14-2.37q12.1-3.45,16.6-3.85,10.26-.4,16.36,8.26,5.37,7.31,6.33,18.2A54,54,0,0,1,1028.45,88.69Zm1-27.51a47,47,0,0,0-1.65-8.34,27.1,27.1,0,0,0-3.25-7.13,15.52,15.52,0,0,0-6.57-1.37h-1a40,40,0,0,0-6.06,1.13q-3.88,1-9.66,2.56-3.45,1-7.38,2.17t-8.5,2.4c-.1,3-.28,6.49-.52,10.31s-.52,8-.84,12.55q-.4,5.85-1.24,14.83t-2,21.25l20.13-4.09v-.16q16.84-3.53,24.38-20a41.48,41.48,0,0,0,3.36-10,53.71,53.71,0,0,0,1-10.7c0-.81,0-1.59-.08-2.37s-.14-1.56-.24-2.36Z" />
              <path class="cls-1"
                  d="M1198.21,96.47l6.42,6.33,1.52,30.47-3.37.56-3.69.65c-1.23.21-2.39.4-3.48.56s-2,.32-2.77.48c-2.46.43-4.57.77-6.33,1s-3.21.51-4.34.72q-10.58,1.92-22.13,4.13T1136.51,146q-12,2.41-24.18,4.93t-24.06,5.18l-6.49-6.5a1.61,1.61,0,0,1-.48.08.74.74,0,0,0-.4.16q2.24-16.27,4.41-32.72T1089.48,85q2-15.76,3.81-30.39t3.24-27.23l19.21-5.65L1131.66,17q11.38-3.37,19.64-5.93t14.08-4.41q5.8-1.85,9.58-3.13c2.51-.86,4.6-1.58,6.25-2.17V2.49l6.5,6.25,2,21.41q-5.2,1.37-10.94,3L1167,36.41q-6,1.68-12.11,3.4l-12,3.41-13.63,4.25c-.16,1.44-.31,3-.44,4.77s-.25,3.62-.36,5.66l6.45-1.73c2.12-.56,4.24-1.13,6.38-1.72q3.93-1.05,8.66-2.41t9.62-2.84q4.89-1.48,9.66-3c3.19-1,6.14-1.94,8.87-2.85v1l6.41,6.42-.56,24.7L1176.56,77c-2.62.54-5.3,1.11-8.06,1.72l-8.34,1.89q-4.2,1-8.22,1.92-3.69,1-7.53,2l-7.78,2h-.16c-3.32,1-6.68,1.85-10.11,2.65-.26,3.8-.48,7.44-.64,10.94s-.32,7-.48,10.39q12.51-2.89,24.1-5.49t22-4.77l4.29-.81,4.21-.8c1.55-.27,3.26-.57,5.13-.92s3.77-.68,5.69-1l4-.68,3.49-.61Zm-3.29,3q-5.28,1-10.94,2t-11.75,2.2q-25.5,5.3-57.25,12.75.39-17.07,1.68-36.4L1131,76.38q6.88-1.8,13.39-3.57,8-1.92,15.43-3.61t14.32-3.13l.4-17.88q-8.26,2.66-16.28,5.05t-16,4.5q-6,1.6-12.07,3.12t-12.31,2.89q1.13-17.64,1.69-25.42l15.71-4.81Q1147,30.07,1158.08,27t21.53-5.89L1178.25,6q-5,1.85-24.62,7.82t-54,16.16q-2.88,25.34-6.53,54.05t-8.06,61.42q47.22-10.43,89.73-18c1.81-.32,4.49-.78,8-1.36s8-1.31,13.31-2.17Z" />
              <path class="cls-1"
                  d="M1,348.87,0,349q2-10.18,4-20.85T7.78,307q1.84-10.5,3.53-20.65t3-19.21q.88-6,1.65-11.74t1.36-10.87q.6-5.13,1.08-9.5t.81-7.74l50.11-15.72a73.15,73.15,0,0,1,11-2.68,66.67,66.67,0,0,1,10.54-.84A49.7,49.7,0,0,1,103,209.5a50.58,50.58,0,0,1,11.11,4.25A45.88,45.88,0,0,1,129,226.34l3,2.89q9.62,9.61,12.67,24.93.56,2.89.84,5.94c.19,2,.28,4.12.28,6.25q0,19.81-12,39.13a82.36,82.36,0,0,1-23.41,25.14,77.44,77.44,0,0,1-31.59,12.31L7.38,355.28ZM112.58,216.8q-18-9.63-42.09-1.93L22.53,230q-.64,6.74-1.8,16.07T17.8,267.56Q12.26,303.8,4.33,344.62l67.12-11.47q34.15-5.77,52.92-36.17,15.31-24.93,10.51-49.15Q130.55,226.67,112.58,216.8Zm-14.91,69Q89.33,304,71.13,307.81l-32,6.42q1.6-17.4,2.69-29.51t1.56-19.33q.65-7.69,1-13.91t.53-11q5.28-1.44,9.74-2.68t8.14-2.37q12.1-3.45,16.6-3.85,10.26-.41,16.35,8.26,5.39,7.31,6.34,18.2A54,54,0,0,1,97.67,285.76Zm1-27.51A47.92,47.92,0,0,0,97,249.91a27.42,27.42,0,0,0-3.25-7.13,15.56,15.56,0,0,0-6.58-1.37h-1a39.9,39.9,0,0,0-6,1.13q-3.9,1-9.66,2.56-3.45,1.05-7.38,2.17t-8.5,2.4q-.16,4.58-.52,10.31t-.84,12.55q-.41,5.85-1.25,14.83t-2,21.25l20.12-4.09v-.16q16.85-3.53,24.38-20a42.17,42.17,0,0,0,3.37-10,54.39,54.39,0,0,0,1-10.7c0-.81,0-1.59-.08-2.37s-.13-1.56-.24-2.36Z" />
              <path class="cls-1"
                  d="M267.43,293.54l6.41,6.33,1.53,30.47-3.37.56-3.69.65c-1.23.21-2.39.4-3.49.56s-2,.32-2.76.48c-2.46.43-4.58.77-6.34,1s-3.21.51-4.33.72q-10.59,1.93-22.13,4.13t-23.54,4.61q-12,2.42-24.17,4.93t-24.06,5.18l-6.5-6.5a1.61,1.61,0,0,1-.48.08.77.77,0,0,0-.4.16q2.25-16.28,4.41-32.71t4.17-32.2q2-15.76,3.81-30.39t3.25-27.23l19.2-5.65,15.92-4.69q11.38-3.37,19.65-5.93t14.07-4.41q5.82-1.84,9.58-3.13c2.52-.86,4.6-1.58,6.26-2.17v1.13l6.49,6.25,2,21.41q-5.22,1.36-11,3l-11.75,3.29-12.1,3.4-12,3.41-13.63,4.25c-.16,1.44-.31,3-.45,4.77s-.25,3.63-.36,5.66l6.46-1.73c2.11-.56,4.24-1.13,6.37-1.72q3.93-1.05,8.66-2.41t9.63-2.84q4.89-1.49,9.66-3t8.86-2.85v1l6.42,6.42-.57,24.7c-2.3.48-4.75,1-7.37,1.52s-5.31,1.11-8.06,1.72l-8.34,1.89q-4.22,1-8.22,1.92-3.69,1.05-7.54,2.05l-7.78,2h-.16q-5,1.45-10.1,2.65c-.27,3.8-.48,7.44-.64,10.95s-.32,7-.48,10.38q12.51-2.88,24.09-5.49t22-4.77l4.29-.81,4.21-.8q2.33-.39,5.14-.92t5.69-1l4.05-.68,3.49-.61Zm-3.29,3q-5.29,1-10.95,2.05t-11.74,2.2q-25.5,5.3-57.26,12.75.41-17.07,1.69-36.4,7.45-1.92,14.35-3.73t13.39-3.57q8-1.92,15.44-3.61t14.31-3.12l.4-17.89q-8.25,2.66-16.28,5.05t-16,4.5q-6,1.6-12.07,3.12t-12.31,2.89q1.13-17.64,1.68-25.42l15.72-4.81q11.79-3.45,22.81-6.54t21.53-5.89l-1.36-15.08q-5,1.84-24.62,7.82t-54,16.16q-2.9,25.33-6.54,54.05t-8.06,61.42q47.24-10.42,89.73-18,2.73-.48,8-1.36T265.34,321Z" />
              <path class="cls-1"
                  d="M335.27,247.43a17.7,17.7,0,0,0-3.61,3.69,14.24,14.24,0,0,0-2.17,4.65c1.45-.21,3.14-.55,5.1-1s4.13-1,6.53-1.57c0,.11.13.11.4,0a6.17,6.17,0,0,0,.72-.32c.38-.11.79-.21,1.25-.32l1.4-.32v-.16l1.08-.2a7.46,7.46,0,0,0,1.33-.36,1.57,1.57,0,0,0,.8-.24c1.07-.22,2.09-.47,3.08-.76s1.89-.58,2.69-.85q19.65-5,30.63-5H387q15.31.65,23.25,11.63l3.69,3.61c1,1,1.87,2.07,2.73,3.16a30.32,30.32,0,0,1,2.4,3.65l.08.16a29.71,29.71,0,0,1,4.09,11.23,45.5,45.5,0,0,1,.89,9q0,22.53-23.18,37.93a101.14,101.14,0,0,1-24.18,11.67,215,215,0,0,1-32.59,8.06,138.31,138.31,0,0,1-22.86,2.16c-1.71,0-3.31,0-4.81-.12a42,42,0,0,1-4.25-.44q-12.75-1.85-26.14-12.19l-5.21-5.05c-.32-.27-.67-.55-1-.84s-.75-.6-1.13-.92L296.54,298a65.25,65.25,0,0,0,10.1,6.21,29.41,29.41,0,0,0,9.22,2.85c.91.11,1.83.2,2.77.28s1.88.12,2.84.12a66.6,66.6,0,0,0,8.26-.6q4.74-.6,10.59-1.73l-.16.08c2.89-.58,5.61-1.22,8.18-1.92s5.1-1.42,7.62-2.17q21.33-6.4,21.33-17.24a.79.79,0,0,0-.08-.32.61.61,0,0,1-.08-.32v-.56a3.63,3.63,0,0,1-.09-.8,2.3,2.3,0,0,0-.16-.88,21.37,21.37,0,0,0-4.25-.4c-.69,0-1.44,0-2.24.12l-2.81.28h.16q-9.3,2-18.28,3.81t-17.72,3.64c-1.66.27-3.29.47-4.89.61s-3.18.2-4.73.2q-10.83,0-16.12-5.38l-4.57-4.33a14.68,14.68,0,0,1-5.29-5.93,17.38,17.38,0,0,1-1.89-5.05,28.78,28.78,0,0,1-.6-6c0-1.06,0-2.08.12-3s.17-1.9.28-2.81a36.29,36.29,0,0,1,5.45-15,54.17,54.17,0,0,1,12.19-13.11,107,107,0,0,1,16.16-10.14,130.86,130.86,0,0,1,19-7.82c5-1.49,9.45-2.74,13.44-3.73a104.91,104.91,0,0,1,10.54-2.12c1.5-.21,3-.39,4.61-.52s3.2-.2,4.85-.2q7.38,0,19.09,2.88l-.4.72,6.57,6.42-14.51,23.41a45.65,45.65,0,0,0-7.18-1.8,40,40,0,0,0-6.21-.52c-.91,0-1.85,0-2.81.08s-2,.16-3.05.32a71.4,71.4,0,0,0-7.49,1.36q-4.62,1.05-11.11,3t-11,3.85A35.65,35.65,0,0,0,335.27,247.43Zm78.18,24.38a27.81,27.81,0,0,0-3.77-10.27q-6.9-12.83-22.69-13.39-10.75-.72-30.95,4.49a61.18,61.18,0,0,1-7.06,1.92c-3,.81-5.24,1.45-6.74,1.93q-11.06,2.88-15.87,2.89-7.78-.09-7.38-6.74.64-9.62,7.7-14.51,5.3-3.85,18.84-7.94,6.74-1.94,11.47-3.05a63.92,63.92,0,0,1,7.7-1.44,42.55,42.55,0,0,1,18.2,1.36l11.06-18a64.32,64.32,0,0,0-22.69-1A180,180,0,0,0,348,213.91q-20.37,6.33-33.28,16.6-15.24,11.7-17.24,26.54-1.61,9.3,1.6,15,5.13,9.61,25.26,6.49l35.85-7.46q18.84-2.47,20.36,11.23Q381.94,297,357,304.36q-3.62,1.13-7.9,2.21t-9.42,2.2q-15.07,2.89-24.22,1.61a37.75,37.75,0,0,1-18-7.38l-14.19,23.65a49.13,49.13,0,0,0,22.53,9.87q11.7,1.68,31-1.61A213.88,213.88,0,0,0,369,327a99.4,99.4,0,0,0,23.45-11.23Q418.59,298.11,413.45,271.81Z" />
              <path class="cls-1"
                  d="M561.88,278.78a.47.47,0,0,0-.16.32,1.41,1.41,0,0,1-.08.4l6.57,6.42q-17.55,47.63-70.48,56.93a51.82,51.82,0,0,1-6.66.84c-2.19.14-4.36.21-6.49.21q-20.77,0-33.84-13.08l-2.33-2.24q-2.24-1.77-4.37-3.81a43.34,43.34,0,0,1-4-4.37,54.49,54.49,0,0,1-8.9-15.6,50.48,50.48,0,0,1-2.88-17.12c0-1.71,0-3.41.16-5.09a46.15,46.15,0,0,1,.56-4.93,70,70,0,0,1,6.41-20.33,93.47,93.47,0,0,1,12.59-19,88.48,88.48,0,0,1,18.2-16.72,84.2,84.2,0,0,1,22.06-10.63,93.27,93.27,0,0,1,13.87-3.53,78.51,78.51,0,0,1,12.91-1.12q18,0,34.48,12.67l-.4.32,6.49,6.42-29.18,19.16a28.51,28.51,0,0,0-7.5-3.65,26.83,26.83,0,0,0-7.82-1.16,47.63,47.63,0,0,0-13.31,2.09,39.65,39.65,0,0,0-22.13,16.11,43.2,43.2,0,0,0-9.06,22.7,6.09,6.09,0,0,0-.17,1.36v1.28a29.47,29.47,0,0,0,3.85,14.92,22.51,22.51,0,0,0,13.15,3.85,36.77,36.77,0,0,0,7.14-.88,49.74,49.74,0,0,0,21.05-9.35,44.72,44.72,0,0,0,13.43-18Zm-34.64-1q-9.3,21.65-36,27.1-17.88,3.45-27.5-8.18-7.94-9.62-7-23a47.91,47.91,0,0,1,9.62-24.06,43.12,43.12,0,0,1,23.82-17.32q18.21-5.29,29.43,2.09l23.9-15.72q-20.37-15.32-54.21-4.57a81.7,81.7,0,0,0-38.73,26.3q-15,17.88-18.12,38.09-3.54,22.53,9.54,38.81,16.28,21.09,48.27,15.64,51.72-8.89,67-51.32Z" />
              <path class="cls-1"
                  d="M610.63,291.21a48.76,48.76,0,0,0,1.21,12.11,20.7,20.7,0,0,0,5.37.64,27.53,27.53,0,0,0,3.69-.28q2.08-.29,4.65-.84a41.62,41.62,0,0,0,14.11-5,26.16,26.16,0,0,0,8.82-8.74q3.45-6.26,3.45-16.44c0-.75,0-1.53-.08-2.33s-.11-1.65-.16-2.56V267q-.41-5.69-1.08-13.35T648.8,236c-.16-1.39-.28-2.75-.36-4.09s-.2-2.62-.36-3.85-.23-2.39-.36-3.49-.23-2.17-.28-3.24c-.11-1.23-.21-2.52-.32-3.85s-.23-2.65-.36-3.93-.26-2.46-.36-3.53-.19-1.95-.24-2.65l31.35-12.18a2.54,2.54,0,0,0,.16,1l6.41,6.41q.09.72.33,2.13c.16.93.33,2,.52,3.09s.4,2.25.64,3.4.44,2.16.6,3l-.16-.08c.11.59.25,1.26.44,2s.36,1.5.52,2.25.24,1.6.4,2.41.3,1.57.4,2.32q.4,2.73.81,4.89c.26,1.45.45,2.7.56,3.77L694,259.62q.88,5.29,1.36,9.54c.32,2.83.59,5.27.8,7.3,0,.59,0,1.2.08,1.84s.08,1.26.08,1.85a55.23,55.23,0,0,1-3.72,20.32,63.11,63.11,0,0,1-11,18,68.28,68.28,0,0,1-20.25,16,91.65,91.65,0,0,1-26.74,8.74q-4.24.72-8.22,1.13c-2.65.26-5.28.4-7.9.4q-19.32,0-29.43-10.19l-3.69-3.69a22.62,22.62,0,0,1-4.25-3.84,29.81,29.81,0,0,1-7-11.55,47.54,47.54,0,0,1-2.25-15.24c0-1.65,0-3.33.16-5s.27-3.38.48-5.09c.06-.16.3-1.65.72-4.45s1-6.83,1.81-12.07,1.72-11.65,2.85-19.25,2.4-16.3,3.84-26.14l28.55-12.19a4.06,4.06,0,0,0-.08.73v.4l6.42,6.41q-1,8.34-1.77,16.24t-1.48,14.75q-.69,6.87-1.2,12.39c-.35,3.69-.6,6.71-.77,9.07q-.32,4-.48,7.05c-.1,2-.16,3.83-.16,5.37Zm68.64-65.83c-.42-3.21-1.15-7.67-2.16-13.4-.54-2.77-1-5.18-1.36-7.21s-.7-3.69-1-5l-24.94,9.7c.27,2.56.59,6,1,10.3s.83,9.59,1.36,15.84q2.25,19.89,2.89,31.27,1.28,14.93-3.53,23.66-6.81,12.27-25.34,15.72Q609.35,310,603.9,301.4q-3.54-5.62-3.13-19.73c0-1.61.05-3.46.16-5.57s.27-4.51.48-7.18q.48-7.05,1.65-18.85t3-28.46l-21.33,9q-8.49,59-8.9,60-3.12,22.77,7.7,34.16,13.15,14.11,43.62,8.66,29-5.06,45.15-23.66,15.32-17.24,14-39.85-.48-6.25-2.17-16.68Z" />
              <path class="cls-1"
                  d="M805.17,290.57l6.41,6.41,5.22,37q-24.54,2.25-38.93,3.77t-18.81,2.41a188.83,188.83,0,0,0-24.5,6.05,237.66,237.66,0,0,0-26,10.06L702,349.67l-.8.4q4.32-19.41,7.33-37.85t5-36.57q1.37-13.47,2-24.33t.68-19.61c0-.59,0-1.23-.08-1.92s-.08-1.47-.08-2.33v-4.25l32-10.1v1l6.49,6.41c0,1.61,0,3.35,0,5.22s0,3.69-.08,5.45-.05,3.38-.08,4.85-.07,2.64-.12,3.49q-.4,13.88-1,29t-1.49,32c2.41-.58,4.75-1.15,7-1.68s4.37-1,6.3-1.44l-.16.16q2.8-.65,7.09-1.45c2.86-.53,6.22-1.15,10.07-1.84,3.63-.59,6.85-1.16,9.66-1.73s5.33-1.08,7.58-1.56l5.69-1.36Zm-3,3.29q-7.14,1.61-19.48,3.85l-11.19,1.92c-3.07.54-5.47,1-7.18,1.44q-10.9,2.25-22.93,5.78,1-20.85,1.76-39.33t1.21-35q.15-2.56.24-6.25t.08-8.5l-25.18,7.94q.56,18.84-2.65,50.2-1.92,18.19-4.61,35.2T706,344.22a185.5,185.5,0,0,1,45.7-14q4.26-.79,18-2.32t36.88-3.61Z" />
              <path class="cls-1"
                  d="M819.84,347.74l-.8.32q1.77-8.73,3.49-18.28t3.33-19.12q1.6-9.59,3-19t2.44-17.8Q833.4,259,834.48,247t1.4-21.13a413.9,413.9,0,0,1,40.74-11q17.4-3.57,29.19-3.57,20.36,0,27.1,10.11l4.49,4.41a14.93,14.93,0,0,1,3.21,4.45,22.2,22.2,0,0,1,1.76,5.49c0,.43.11.91.16,1.44s.08,1.1.08,1.69q0,16.35-28.46,35a228.47,228.47,0,0,1-22.22,12.63q-11.94,6-25.66,11.35l-2.88,46.27-37,10.1Zm19.33-119.48q-.31,8.51-1.4,20t-3,26.06q-2.09,17-4.89,34.12t-6.34,34.84L853.68,335l2.89-46.1q28.63-11,49.08-24.22,29.42-19.32,26.86-35.12Q927.7,200.51,839.17,228.26Zm62.23,14.12q-6.66,11.77-43.39,24.21l1.37-24a50.07,50.07,0,0,0,6.41-1.93c1.39-.48,2.59-.88,3.61-1.2a20,20,0,0,1,2.49-.64q29.58-8.67,30.47.4A7.55,7.55,0,0,1,901.4,242.38Zm-32.72,16.68q18.92-7.38,26.14-14.12c-2.14.38-4.5.86-7.1,1.45s-5.36,1.31-8.3,2.16c-.26.11-.92.31-2,.6s-2.31.74-3.81,1.33a21,21,0,0,1-2.12.72l-2.37.64Z" />
              <path class="cls-1"
                  d="M1071.56,314.47l6.57,6.49-47.39,17.48-6.58-6.41-.4.16q-3.36-4.57-6.65-9.83t-6.5-11.1c-2.19.53-4.28,1-6.25,1.48l-5.62,1.32q-5,1.05-9.58,1.81T980,317q-2.57,8.74-5.17,17t-4.69,14.72l-35.45-.16-6.41-6.42h-1.12q2.72-6.5,6-14.35t6.7-16.64q3.44-8.79,6.93-18.08t6.86-18.69q6-16.83,10.66-31.27t7.62-25.1l25.74-6.58c.11.27.2.52.28.77s.18.49.28.76l6,5.93a263.37,263.37,0,0,0,20.49,39.61,282.07,282.07,0,0,0,27,36q4.82,5.21,9.94,10.1t10.51,9.63Zm-6-1.45a270.65,270.65,0,0,1-69.92-97.43l-20.85,5.3q-3,10.58-7.46,24.13t-10.42,30.47q-13.47,37.45-24.54,63.27l28.71.08q2.24-6.73,4.69-14.59t5.17-17c3.1-.27,6.35-.65,9.74-1.16s7-1.14,10.71-1.89q7.77-1.76,17.32-4.33A210.27,210.27,0,0,0,1025,327.94Zm-64.63-29.83c-3,.75-5.57,1.38-7.58,1.89s-3.49.87-4.45,1.08q-2.57.64-5.65,1.32c-2.06.46-4.32.92-6.78,1.41q7-24.78,11.07-40.18,3,8.74,6.25,17.28T1000.91,283.19Zm-8.5-1.36a10.78,10.78,0,0,1,1.6-.44c.64-.13,1.34-.31,2.09-.52-.59-1.34-1.14-2.68-1.65-4s-1.05-2.65-1.64-3.93q-.72,2.25-1.4,4.65t-1.33,4.89l1.09-.32C991.51,282,991.93,281.94,992.41,281.83Z" />
              <path class="cls-1"
                  d="M1137.23,247.43a18,18,0,0,0-3.61,3.69,14.22,14.22,0,0,0-2.16,4.65c1.44-.21,3.14-.55,5.09-1s4.13-1,6.53-1.57c0,.11.14.11.4,0a7.24,7.24,0,0,0,.73-.32c.37-.11.78-.21,1.24-.32l1.4-.32v-.16l1.08-.2a7.46,7.46,0,0,0,1.33-.36,1.57,1.57,0,0,0,.8-.24c1.07-.22,2.1-.47,3.09-.76s1.88-.58,2.68-.85q19.65-5,30.63-5H1189q15.32.65,23.26,11.63l3.68,3.61c1,1,1.87,2.07,2.73,3.16a30.36,30.36,0,0,1,2.41,3.65l.08.16a30,30,0,0,1,4.09,11.23,46.27,46.27,0,0,1,.88,9q0,22.53-23.18,37.93a101.25,101.25,0,0,1-24.17,11.67,215.12,215.12,0,0,1-32.6,8.06,138.29,138.29,0,0,1-22.85,2.16c-1.71,0-3.32,0-4.81-.12a41.45,41.45,0,0,1-4.25-.44q-12.75-1.85-26.15-12.19l-5.21-5.05c-.32-.27-.67-.55-1-.84s-.75-.6-1.12-.92L1098.5,298a65.73,65.73,0,0,0,10.1,6.21,29.49,29.49,0,0,0,9.22,2.85c.91.11,1.83.2,2.77.28s1.88.12,2.85.12a66.87,66.87,0,0,0,8.26-.6q4.72-.6,10.58-1.73l-.16.08c2.89-.58,5.61-1.22,8.18-1.92s5.1-1.42,7.62-2.17q21.33-6.4,21.33-17.24a.79.79,0,0,0-.08-.32.61.61,0,0,1-.08-.32v-.56a3.62,3.62,0,0,1-.08-.8,2.5,2.5,0,0,0-.16-.88,21.52,21.52,0,0,0-4.25-.4q-1,0-2.25.12l-2.81.28h.17q-9.32,2-18.29,3.81t-17.72,3.64c-1.66.27-3.29.47-4.89.61s-3.18.2-4.73.2q-10.83,0-16.12-5.38l-4.57-4.33a14.76,14.76,0,0,1-5.29-5.93,17.38,17.38,0,0,1-1.89-5.05,28.78,28.78,0,0,1-.6-6c0-1.06,0-2.08.12-3s.18-1.9.28-2.81a36.31,36.31,0,0,1,5.46-15,54.12,54.12,0,0,1,12.18-13.11,107.53,107.53,0,0,1,16.16-10.14,130.53,130.53,0,0,1,19-7.82q7.46-2.24,13.43-3.73a105.47,105.47,0,0,1,10.54-2.12c1.5-.21,3-.39,4.61-.52s3.2-.2,4.85-.2q7.38,0,19.09,2.88l-.4.72,6.57,6.42L1193,237.48a45.65,45.65,0,0,0-7.18-1.8,40,40,0,0,0-6.21-.52c-.91,0-1.85,0-2.81.08s-2,.16-3,.32a71.4,71.4,0,0,0-7.49,1.36q-4.62,1.05-11.11,3t-10.94,3.85A35.48,35.48,0,0,0,1137.23,247.43Zm78.18,24.38a27.81,27.81,0,0,0-3.77-10.27q-6.89-12.83-22.69-13.39-10.74-.72-31,4.49a61.18,61.18,0,0,1-7.06,1.92c-3,.81-5.24,1.45-6.73,1.93q-11.07,2.88-15.88,2.89-7.78-.09-7.38-6.74.65-9.62,7.7-14.51,5.3-3.85,18.84-7.94,6.73-1.94,11.47-3.05a63.92,63.92,0,0,1,7.7-1.44,42.55,42.55,0,0,1,18.2,1.36l11.07-18a64.39,64.39,0,0,0-22.7-1,180.41,180.41,0,0,0-23.25,5.77q-20.37,6.33-33.28,16.6-15.24,11.7-17.24,26.54-1.61,9.3,1.6,15,5.14,9.61,25.26,6.49l35.85-7.46q18.84-2.47,20.37,11.23,1.35,14.67-23.58,22.05-3.62,1.13-7.9,2.21t-9.42,2.2q-15.08,2.89-24.22,1.61a37.75,37.75,0,0,1-18-7.38l-14.19,23.65a49.13,49.13,0,0,0,22.53,9.87q11.7,1.68,31-1.61A213.58,213.58,0,0,0,1171,327a99.4,99.4,0,0,0,23.45-11.23Q1220.54,298.11,1215.41,271.81Z" />
              <path class="cls-1"
                  d="M1282.13,207.9l-.16,1,6.57,6.41-3.36,86.37-1.69.24v.32l6.42,6.25,1.52,31.76-38.73,5.21-6.58-6.58-.64.16,2-29.43,22.21-5.21-10.58,1.77-6.42-6.42-.8.16c.11-1.49.23-3.23.36-5.21s.25-4.05.36-6.22.21-4.3.32-6.41.16-4,.16-5.81v-2.09q0-3-.16-8.46t-.44-12.83q-.29-7.41-.72-16.72t-1-20.13Zm-1.92,97.42-29.43,7L1249.17,335l32.32-4.17Zm-25.83-86.92q2.41,47.23,2.17,57.82t-1,19.4l19.88-3.45,3.13-79.86Z" />
          </svg>
      </div>
  </div>

</section> -->

<section id="depoimentos">
  <div class="d-flex azul-logo align-items-center mb-3 container-fluid py-4">
    <h1 class="ms-4 my-4 container font-montserrat-bold">
      <span class="display-3 border-0 border-bottom border-warning">Veja</span
      ><br /><span class="ms-5">o que falam por aí!!!</span>
    </h1>
    <!-- <div class="d-flex flex-column ms-md-5 mx-2 align-items-center ">
          <label for="">Ouça que bacana que um usuário disse</label>

          <audio controls>
              <source src="./assets/audio/deusorteparanos.mp3" type="audio/mpeg">
              Seu navegador não suporta o elemento de áudio.
          </audio>
      </div> -->
  </div>
  <div class="row mx-auto mb-5 container">
    <div class="offset-md-1 col-md-8 mx-auto mb-3">
      <div class="card mb-2" *ngFor="let av of avaliacoes">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-1 text-center">
              <img
                src="{{ av.img }}"
                alt="icon avaliação playstore"
                class="rounded rounded-circle"
              />
            </div>
            <div class="col-md-5 col-10">
              <p>
                <b>{{ av.nomeCliente }}</b>
                <br />
                <span><i class="fas fa-star text-warning"></i></span>
                <span><i class="fas fa-star text-warning"></i></span>
                <span><i class="fas fa-star text-warning"></i></span
                ><span><i class="fas fa-star text-warning"></i></span
                ><span><i class="fas fa-star text-warning"></i></span>
              </p>
            </div>
            <div class="col-md-6 col-2 text-right">
              <i class="fas fa-thumbs-up text-muted"></i>
              <br />
              <span class="text-secondary"
                ><sup>{{ av.likes }}</sup></span
              >
            </div>
            <div class="col-12">
              <p class="">{{ av.comentario }}</p>
            </div>
            <div
              class="col-11 resposta mb-1 bg-light rounded-lg mx-auto shadow border"
            >
              <p class="small text-primary mb-1 mt-2">
                <i class="fas fa-reply"></i> Meu Vidraceiro
              </p>
              <p class="mb-3">{{ av.resposta }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="container-fluid text-white">
  <h3 class="text-center text-dark pt-5 font-montserrat-bold">
    Baixe agora mesmo!
  </h3>
  <p class="text-center lead text-dark">
    A única coisa que você irá perder é a oportunidade de mudar o jeito como
    seus clientes vêem sua empresa.
  </p>
  <div
    class="d-flex align-items-center pb-5 justify-content-center flex-column"
  >
    <div class="row mb-4">
      <a
        href="https://play.google.com/store/apps/details?id=br.com.zemt.zemtVidraceiro"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/google-play.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
      <a
        href="https://apps.apple.com/br/app/meu-vidraceiro/id1479886116"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/app-store.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
      <a
        href="https://app.meuvidraceiro.com.br"
        target="_blank"
        class="btn text-white col-md-4"
      >
        <img
          src="./assets/img/web.svg"
          width="170"
          class="img-fluid rounded"
          alt=""
        />
      </a>
    </div>

    <button
      class="btn botao animation rounded-pill p-3 px-4 font-weight-bold"
      (click)="btnDownload()"
    >
      FAÇA O TESTE GRÁTIS <i class="fas fa-arrow-right"></i>
    </button>
  </div>
</div>
<div id="footer-whatsapp" class="row">
  <div class="col-12">
    <div class="d-flex align-items-center justify-content-center mr-3 mb-1">
      <div class="whatsapp mb-4">
        <div class="btn-group">
          <a
            type="button"
            class="btn btn-success mr-md-4 mr-2"
            href="https://api.whatsapp.com/send?L=pt&phone=5531994022464&text=Ol%C3%A1%20Gostaria%20de%20falar%20com%20um%20atendente"
            target="_blank"
          >
            <i class="fab fa-whatsapp mr-2"></i
            ><small style="font-size: 0.7em"> Quero falar com atendente </small>
          </a>
          <!-- div class="dropdown-menu bg-light w-100">  #formWhatsapp="ngForm" 
                  <form [formGroup]='fmsg' (submit)="submitWhatsapp()">
                      <div class="card bg-light border-0">

                          <div class="card-body bg-light">
                              <div class="text-center mt-2 pb-2 border-0 border-bottom ">
                                  <img src="./assets/img/logo.svg" height="36" alt="Logo meu vidraceiro">
                              </div>

                              <div class="form-group mt-3">
                                  <input type="text" formControlName="nome" class="form-control"
                                      placeholder="Seu nome">
                                   <app-error-msg [control]="fmsg.get('nome')" label="Nome">
                                  </app-error-msg> 
                              </div>
                              <br>
                              <div class="form-group">
                                  <label for="msg">Mensagem*</label>
                                  <textarea class="form-control" formControlName="msg" rows="3"></textarea>
                              </div>
                          </div>
                          <div class="card-footer text-muted text-end bg-transparent border-0">
                              <button type="submit" class="btn btn-success rounded-pill"> enviar</button>
                          </div>
                      </div>
                  </form> 
              </div>-->
        </div>
      </div>
      <div class="arrow-top" *ngIf="posicaoY > 0">
        <i
          (click)="irparaotopo()"
          class="btn fas fa-arrow-circle-up fa-3x float-end me-md-4 mb-4 me-2"
        ></i>
      </div>
    </div>
  </div>
</div>
